module.exports = __webpack_public_path__ + "static/media/search-icon.2f4493bb.svg";